import { render, staticRenderFns } from "./CarHealthAggregateState.vue?vue&type=template&id=0bb39315&"
import script from "./CarHealthAggregateState.vue?vue&type=script&lang=ts&"
export * from "./CarHealthAggregateState.vue?vue&type=script&lang=ts&"
import style0 from "./CarHealthAggregateState.vue?vue&type=style&index=0&id=0bb39315&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports